import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { baseColors, DotLoader, RelodeTheme } from "../";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            statTile: {
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                flexDirection: "column",
                flexGrow: 1,
                [theme.breakpoints.down("sm")]: {
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: theme.spacing(2),
                },
            },
            statTileTitle: {
                textTransform: "lowercase",
                fontFamily: [
                    // eslint-disable-next-line quotes
                    '"hkgrotesk_regular"',
                    "Helvetica",
                    "sans-serif",
                ].join(","),
                fontSize: 16,
                lineHeight: "22px",
                color: baseColors.gray,
                marginBottom: theme.spacing(0.5),
            },
            statTileContent: {
                fontSize: 28,
                fontStyle: "normal",
                lineHeight: "34px",
                height: "34px",
                fontWeight: "bold",
                margin: 0,
                fontFamily: [
                    // eslint-disable-next-line quotes
                    '"hkgrotesk_bold"',
                    "Helvetica",
                    "sans-serif",
                ].join(","),
                color: baseColors.navy,
            },
            statTileContentLoader: {
                marginLeft: theme.spacing(2),
                [theme.breakpoints.down("sm")]: {
                    marginLeft: 0,
                },
            },
        }),
    { name: "StatTile" }
);
interface StatTileProps {
    id: string;
    title: string;
    content: string;
    isBusy?: boolean;
}

export const StatTile = (props: StatTileProps) => {
    const classes = useStyles(props);
    const { id, title, content, isBusy } = props;

    return (
        <div id={id} className={classes.statTile}>
            <div className={classes.statTileTitle}>{title}</div>

            <div className={classes.statTileContent}>
                {isBusy ? (
                    <DotLoader className={classes.statTileContentLoader} />
                ) : (
                    content
                )}
            </div>
        </div>
    );
};
